export var getFlowApiEnvironment = function (wixCodeApi) {
    var viewMode = wixCodeApi.window.viewMode.toLowerCase();
    return {
        isPreviewMode: viewMode === 'preview',
        isEditorMode: viewMode === 'editor',
        isSiteMode: viewMode === 'site',
        isSSR: wixCodeApi.window.rendering.env === 'backend',
        isSEO: wixCodeApi.seo.isInSEO(),
    };
};
//# sourceMappingURL=getFlowApiEnvironment.js.map